export const FONTS = {
  TEXT_MEDIUM_FUTURA: 'Futura, sans-serif ',
  TEXT_REGULAR_INTER: 'Inter, sans-serif',
}